// extracted by mini-css-extract-plugin
export default {"fr-view":"SplashScreen_fr-view__EOVHL","container":"SplashScreen_container__iwyJ5","image":"SplashScreen_image__vZ2LC"};